var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38891 1.28442C1.86865 0.804822 2.51923 0.5354 3.19758 0.5354C3.87594 0.5354 4.52652 0.804822 5.00626 1.28442L14.0522 10.3303L23.0981 1.28442C23.5806 0.818414 24.2268 0.560558 24.8976 0.566387C25.5683 0.572215 26.21 0.841263 26.6843 1.31558C27.1586 1.7899 27.4277 2.43154 27.4335 3.1023C27.4393 3.77306 27.1815 4.41928 26.7155 4.90177L17.6695 13.9477L26.7155 22.9936C27.1815 23.4761 27.4393 24.1223 27.4335 24.7931C27.4277 25.4639 27.1586 26.1055 26.6843 26.5798C26.21 27.0541 25.5683 27.3232 24.8976 27.329C24.2268 27.3348 23.5806 27.077 23.0981 26.611L14.0522 17.565L5.00626 26.611C4.52377 27.077 3.87755 27.3348 3.20679 27.329C2.53603 27.3232 1.89439 27.0541 1.42007 26.5798C0.945755 26.1055 0.676708 25.4639 0.670879 24.7931C0.66505 24.1223 0.922906 23.4761 1.38891 22.9936L10.4348 13.9477L1.38891 4.90177C0.909314 4.42203 0.639893 3.77144 0.639893 3.09309C0.639893 2.41474 0.909314 1.76416 1.38891 1.28442Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.da238de48e79169389eb7a41020035f9.svg";
export { ForwardRef as ReactComponent };